export interface LoggerOptions {
  /**
   * stack trace 打印的行数，默认为3
   */
  printStackStartLine?: number;
  /**
   * 设置默认状态为关闭
   */
  disable?: boolean;
  /**
   * 在web端也关闭log
   */
  disableInWeb?: boolean;
}
interface LogStyles {
  warn: string;
  error: string;
  log: string;
}

interface loggerInitInfo {
  logPrefix?: string;
  name?: string;
  enableStackTrace?: boolean;
  options?: LoggerOptions;
}

export class Logger {
  private isMute = false;
  private logPrefix = '[EVO-VUE]';
  private infoHead = `${this.logPrefix}[Logger]`;
  private headStyle = ['color: rgb(42, 83, 205)', 'font-weight: 900'].join(';');
  private options: LoggerOptions;
  /**
   * 定位console.log源头
   */
  private enableStackTrace: boolean;

  public constructor({
    logPrefix,
    name,
    enableStackTrace = false,
    options,
  }: loggerInitInfo) {
    if (logPrefix) {
      this.logPrefix = `[${logPrefix}]`;
    }
    if (name) {
      this.infoHead = `${this.logPrefix}[${name}]`;
    }
    this.options = options || {
      disableInWeb: true,
    };
    this.options.printStackStartLine = this.options.printStackStartLine ?? 3;
    this.enableStackTrace = enableStackTrace;
    if (!import.meta.env.EVO && this.options?.disableInWeb) {
      this.isMute = true;
    }
    if (this.options?.disable) {
      this.isMute = true;
    }
  }

  public log(...args: unknown[]): void {
    if (this.isMute) {
      return;
    }
    console.info(
      `%c${this.infoHead}`,
      this.logStyle.log,
      args[0],
      ...args.slice(1),
      this.getPrintStack(),
    );
  }

  public warn(...args: unknown[]): void {
    if (this.isMute) {
      return;
    }
    console.warn(
      `%c${this.infoHead}`,
      this.logStyle.warn,
      args[0],
      ...args.slice(1),
      this.getPrintStack(),
    );
  }

  public error(...args: unknown[]): void {
    if (this.isMute) {
      return;
    }
    console.error(
      `%c${this.infoHead}`,
      this.logStyle.error,
      args[0],
      ...args.slice(1),
    );
  }

  public logKV(key: string, ...value: unknown[]): void {
    if (this.isMute) {
      return;
    }
    console.info(
      `%c${this.infoHead} %c${key}:`,
      this.headStyle,
      'color: #45af7e; font-weight: bold',
      ...value,
      this.getPrintStack(),
    );
  }

  public mute(): void {
    this.isMute = true;
  }

  public unmute(): void {
    this.isMute = false;
  }

  private get logStyle(): LogStyles {
    return {
      log: ['color: #007500', 'font-weight: 900'].join(';'),
      error: ['color: red', 'font-weight: 900'].join(';'),
      warn: ['color: #ec6646', 'font-weight: 900'].join(';'),
    };
  }

  private getPrintStack() {
    if (this.enableStackTrace) {
      const stackTrace = new Error().stack;
      const stackTraceArr = stackTrace?.split('\n');
      const logPos = stackTraceArr?.[this.options.printStackStartLine!];
      return `\n${logPos || ''}`;
    }
    return '';
  }
}
